<section class="animated fadeIn">
  <section class="mt-2">
    <nes-text color="blue" tabindex="0" *ngIf="totalProductCount > 1">
      {{ 'CARD' | translate }} {{ productNumber }}/{{ totalProductCount }}
    </nes-text>
    <h2 [cypress]="'product_title'" class="headingS">
      <strong>{{
        'COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS.' + product.identifier + '.TITLE' | translate
      }}</strong>
      <span class="pricedetails float-right">€ {{ product.price | priceFormat }}</span>
    </h2>
  </section>
  <section class="mb-2">
    <div *ngIf="product.route as route">{{ route.from.naam }} - {{ route.to.naam }}</div>
    <ng-container *ngIf="product | displayServices | async; else default">
      <nes-text size="sm">{{ product | displayServices | async }}</nes-text>
    </ng-container>
    <ng-template #default>
      <nes-text> {{'VERIFY.NO_DTD' | translate}}</nes-text>
    </ng-template>
  <nes-text  size="sm" *ngIf="product | displayServices | async">{{ 'VERIFY.DTD_TEXT' | translate }}</nes-text>

    <a
      class="link link-icon link--edit"
      [cypress]="'edit_product'"
      (click)="edit.emit(product)"
    >
      <i class="icon edit--small icon--top-left"></i>
      {{ 'BUTTON.EDIT' | translate }}
    </a>
    <a
      class="link link-icon"
      [cypress]="'delete_product'"
      (click)="delete.emit(product)"
    >
      <i class="icon trash--small icon--top-left"></i>
      {{ 'BUTTON.DELETE' | translate }}
    </a>
  </section>
  <section *ngIf="product.user as user" class="mb-2">
    <div class="product-container">
      <div alt="" class="image-container" privacySensitive aria-hidden="true">
        <div class="card-image">
          <div *ngIf="user.image as image" class="user-image">
            <img [src]="image.imageAsBase64 | displayImage" />
          </div>
          <div class="user-name">{{ user | displayName | async }}</div>
          <div class="user-company">{{ company.name | truncate: 20 }}</div>
          <div class="user-birthdate">
            <span>{{ 'VERIFY.BIRTH_DATE' | translate }}</span>
            {{ user.birthDate.date | dateFormat: 'DD-MM-YYYY' }}
          </div>
        </div>
      </div>
      
      <div class="user-details" [cypress]="'user_details'" privacySensitive>
        <nes-heading tag="h3" size="base" class="nes-mb-2">
          {{ user | displayName | async }}
        </nes-heading>
        <div>
          {{ user.birthDate.date | dateFormat: 'D MMMM YYYY' }}
        </div>
        <ng-container *ngIf="user.address as address">
          <div>{{ address.street }} {{ address.houseNumber }} {{ address.addition }},</div>
          <div>{{ address.postcode }} {{ address.city }} {{ user.country.name }}</div>
        </ng-container>
        <div>{{ user.email }}</div>
        <ng-container *ngIf="user.useProduct.type == ProductStart.DATE && user.useProduct.date as useProductDate; else directly">
          <div>
            {{ 'VERIFY.USE_PRODUCT' | translate }}:
            <strong>
              {{ useProductDate | dateFormat: 'D MMMM YYYY' }}
            </strong>
          </div>
        </ng-container>
        <ng-template #directly>
          <div class="mb-1">
            {{ 'VERIFY.USE_PRODUCT' | translate }}:
            <strong>{{ 'VERIFY.DIRECTLY' | translate }}</strong>
          </div>
        </ng-template>
        <a
          class="link"
          [cypress]="'edit_user'"
          (click)="editUser.emit(product)"
        >
        <nes-text weight="bold" size="sm" color="blue-500">

          {{ 'VERIFY.BUTTON.EDIT_USER' | translate }}
        </nes-text>
        </a>
      </div>
    </div>
  </section>

  <ng-container *ngFor="let addon of product.addons">
    <bca-product-addon *ngIf="addon.selected" [addon]="addon" (delete)="deleteAddon.emit($event)">
    </bca-product-addon>
  </ng-container>

  <nes-divider class="nes-mb-5"></nes-divider>
</section>
